module.exports = __webpack_public_path__ + "static/media/N. Lenore, Willits, CA (2 Buildings)12.50e45ab0.jpg";